// import React, { useState, useEffect } from 'react';
// import {
// 	Box,
// 	Typography,
// 	Paper,
// 	TextField,
// 	IconButton,
// 	Button,
// 	Switch,
// 	Grid2,
// } from '@mui/material';
// import { motion } from 'framer-motion';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
// import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
// import { MePUTADDress } from '../../../../../services/api/Vendorpage/me';
// import ProfileModalResponse from '../../Vendor-ui/profilemodal';

// interface Address {
// 	_id?: string;
// 	title: string;
// 	address?: string;
// 	city: string;
// 	country: string;
// 	state: string;
// 	zipCode: string;
// 	active?: boolean;
// }

// const addressSectionAnimation = {
// 	hidden: { opacity: 0, y: 20 },
// 	visible: (i: number) => ({
// 		opacity: 1,
// 		y: 0,
// 		transition: { delay: i * 0.1, duration: 0.4 },
// 	}),
// };

// export default function AddressCard({ Vendorme }: any) {
// 	const [addresses, setAddresses] = useState<Address[]>([]);
// 	const [editMode, setEditMode] = useState(false);
// 	const slug = localStorage.getItem('slug');
// 	const [responseModal, setResponseModal] = useState<any>({
// 		open: false,
// 		isSuccess: false,
// 		message: '',
// 		responseData: '',
// 	});

// 	// ✅ Populate state with Vendorme data
// 	useEffect(() => {
// 		if (Vendorme?.shippingAddress?.length > 0) {
// 			const mapped = Vendorme.shippingAddress.map((addr: any, i: number) => ({
// 				_id: addr?._id,
// 				title: `Shipping Address ${i + 1}`,
// 				address: addr?.address || '',
// 				city: addr?.city || '',
// 				country: addr?.country || '',
// 				state: addr?.state || '',
// 				zipCode: addr?.zipCode || '',
// 				active: addr?.active ?? false,
// 			}));
// 			setAddresses(mapped);
// 		}
// 	}, [Vendorme]);

// 	// ✅ Handle field change
// 	// ✅ Strong typing fix
// 	const handleChange = (index: number, field: keyof Address, value: string) => {
// 		const newAddresses = [...addresses];
// 		newAddresses[index] = {
// 			...newAddresses[index],
// 			[field]: value, // TS now knows field is always valid
// 		};
// 		setAddresses(newAddresses);
// 	};

// 	// ✅ Handle active switch (only one active at a time)
// 	const handleActiveSwitch = (index?: number) => {
// 		const updated = addresses.map((addr, i) => ({
// 			...addr,
// 			active: i === index, // only one true
// 		}));
// 		setAddresses(updated);
// 	};

// 	// ✅ Add new address
// 	const handleAddAddress = () => {
// 		const newAddress: Address = {
// 			title: `Shipping Address ${addresses.length + 1}`,
// 			address: '',
// 			city: '',
// 			country: '',
// 			state: '',
// 			zipCode: '',
// 			active: addresses.length === 0, // first one active by default
// 		};
// 		setAddresses([...addresses, newAddress]);
// 		setEditMode(true);
// 	};

// 	// ✅ Save last address
// 	const handleSave = async () => {
// 		if (addresses.length === 0) return;

// 		const lastAddress = addresses[addresses.length - 1];

// 		const response = await MePUTADDress(`vendors/${slug}/me/shipping-address`, lastAddress);
// 		console.log(response, 'response');
// 		if (response.success) {
// 			setResponseModal({
// 				open: true,
// 				isSuccess: true,
// 				message: 'Profile updated successfully!',
// 				responseData: null,
// 			});
// 		} else {
// 			setResponseModal({
// 				open: true,
// 				isSuccess: false,
// 				message: 'Profile updated successfully!',
// 				responseData: null,
// 			});
// 		}

// 		setEditMode(false);
// 	};

// 	return (
// 		<Paper
// 			component={motion.div}
// 			initial={{ opacity: 0, scale: 0.95 }}
// 			animate={{ opacity: 1, scale: 1 }}
// 			transition={{ duration: 0.5 }}
// 			sx={{
// 				borderRadius: 2,
// 				boxShadow: '0px 4px 4px rgba(0,0,0,0.1)',
// 				overflow: 'hidden',
// 				bgcolor: 'white',
// 				position: 'relative',
// 			}}
// 		>
// 			{/* Header */}
// 			<Box
// 				sx={{
// 					p: '5px',
// 					bgcolor: '#1B663C',
// 					display: 'flex',
// 					alignItems: 'center',
// 					px: 3,
// 					color: 'white',
// 					justifyContent: 'space-between',
// 				}}
// 				component={motion.div}
// 				initial={{ y: -50 }}
// 				animate={{ y: 0 }}
// 				transition={{ duration: 0.4 }}
// 			>
// 				<Box
// 					sx={{
// 						display: 'flex',
// 						justifyContent: 'space-between',
// 						alignItems: 'center',
// 						gap: 1,
// 					}}
// 				>
// 					<LocationOnIcon />
// 					<Typography
// 						sx={{ fontSize: { xs: 14, sm: 16, md: 18 } }}
// 						variant="h6"
// 						fontWeight={'semibold'}
// 						fontFamily="Poppins"
// 					>
// 						Address Details
// 					</Typography>
// 				</Box>
// 				<Box>
// 					<IconButton onClick={handleAddAddress} sx={{ color: 'white' }}>
// 						<AddLocationAltIcon />
// 					</IconButton>
// 					<IconButton onClick={() => setEditMode(!editMode)} sx={{ color: 'white' }}>
// 						<DriveFileRenameOutlineIcon />
// 					</IconButton>
// 				</Box>
// 			</Box>

// 			{/* Content */}
// 			<Box sx={{ p: 2 }}>
// 				{addresses.map((addr, index) => (
// 					<Box key={addr._id || index} sx={{ mb: 2.5 }}>
// 						<Typography
// 							variant="h6"
// 							sx={{
// 								color: 'green',
// 								mb: 2,
// 								fontFamily: 'Poppins',
// 								fontWeight: 600,
// 								fontSize: { xs: 14, sm: 16, md: 18 },
// 							}}
// 							component={motion.div}
// 							custom={index}
// 							initial="hidden"
// 							animate="visible"
// 							variants={addressSectionAnimation}
// 						>
// 							{addr.title}
// 						</Typography>

// 						<Grid2
// 							container
// 							spacing={3}
// 							component={motion.div}
// 							custom={index + 1}
// 							initial="hidden"
// 							animate="visible"
// 							variants={addressSectionAnimation}
// 						>
// 							{editMode ? (
// 								<>
// 									<Grid2 size={{ xs: 12, sm: 4 }}>
// 										<TextField
// 											label="Door no / Street"
// 											variant="outlined"
// 											size="small"
// 											fullWidth
// 											value={addr.address}
// 											onChange={(e) =>
// 												handleChange(
// 													index as any,
// 													'address',
// 													e.target.value
// 												)
// 											}
// 										/>
// 									</Grid2>
// 									<Grid2 size={{ xs: 12, sm: 5 }}>
// 										<TextField
// 											label="City"
// 											variant="outlined"
// 											size="small"
// 											fullWidth
// 											value={addr.city}
// 											multiline
// 											minRows={1}
// 											onChange={(e) =>
// 												handleChange(index as any, 'city', e.target.value)
// 											}
// 											InputProps={{
// 												sx: {
// 													whiteSpace: 'normal', // allow wrapping
// 													wordBreak: 'break-word',
// 												},
// 											}}
// 										/>
// 									</Grid2>
// 									<Grid2 size={{ xs: 12, sm: 3 }}>
// 										<TextField
// 											label="Country"
// 											variant="outlined"
// 											size="small"
// 											fullWidth
// 											value={addr.country}
// 											onChange={(e) =>
// 												handleChange(
// 													index as any,
// 													'country',
// 													e.target.value
// 												)
// 											}
// 										/>
// 									</Grid2>
// 									<Grid2 size={{ xs: 12, sm: 4 }}>
// 										<TextField
// 											label="State"
// 											variant="outlined"
// 											size="small"
// 											fullWidth
// 											value={addr.state}
// 											onChange={(e) =>
// 												handleChange(index as any, 'state', e.target.value)
// 											}
// 										/>
// 									</Grid2>
// 									<Grid2 size={{ xs: 12, sm: 4 }}>
// 										<TextField
// 											label="Zip Code"
// 											variant="outlined"
// 											size="small"
// 											fullWidth
// 											value={addr.zipCode}
// 											onChange={(e) =>
// 												handleChange(
// 													index as any,
// 													'zipCode',
// 													e.target.value
// 												)
// 											}
// 										/>
// 									</Grid2>

// 									{/* Active switch */}
// 									<Grid2 size={{ xs: 12, sm: 4 }}>
// 										<Typography variant="body2" color="text.secondary">
// 											Active
// 										</Typography>
// 										<Switch
// 											checked={addr.active ?? false}
// 											onChange={() => handleActiveSwitch(index)}
// 											color="success"
// 										/>
// 									</Grid2>
// 								</>
// 							) : (
// 								<>
// 									<Grid2 size={{ xs: 12, sm: 4 }}>
// 										<Typography variant="body2" color="text.secondary">
// 											Door no / Street
// 										</Typography>
// 										<Typography variant="body1">
// 											{addr.address || '-'}
// 										</Typography>
// 									</Grid2>
// 									<Grid2 size={{ xs: 12, sm: 4 }}>
// 										<Typography variant="body2" color="text.secondary">
// 											City
// 										</Typography>
// 										<Typography variant="body1">{addr.city}</Typography>
// 									</Grid2>
// 									<Grid2 size={{ xs: 12, sm: 4 }}>
// 										<Typography variant="body2" color="text.secondary">
// 											Country
// 										</Typography>
// 										<Typography variant="body1">{addr.country}</Typography>
// 									</Grid2>
// 									<Grid2 size={{ xs: 12, sm: 4 }}>
// 										<Typography variant="body2" color="text.secondary">
// 											State
// 										</Typography>
// 										<Typography variant="body1">{addr.state}</Typography>
// 									</Grid2>
// 									<Grid2 size={{ xs: 12, sm: 4 }}>
// 										<Typography variant="body2" color="text.secondary">
// 											Zip Code
// 										</Typography>
// 										<Typography variant="body1">{addr.zipCode}</Typography>
// 									</Grid2>
// 									<Grid2 size={{ xs: 12, sm: 4 }}>
// 										<Typography variant="body2" color="text.secondary">
// 											Active
// 										</Typography>
// 										<Typography variant="body1">
// 											{addr.active ? 'Yes' : 'No'}
// 										</Typography>
// 									</Grid2>
// 								</>
// 							)}
// 						</Grid2>
// 					</Box>
// 				))}

// 				{editMode && (
// 					<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
// 						<Button
// 							variant="contained"
// 							sx={{ bgcolor: '#1B663C', px: 5, py: 1.5, borderRadius: 2 }}
// 							onClick={handleSave}
// 						>
// 							Save
// 						</Button>
// 					</Box>
// 				)}
// 			</Box>
// 			<ProfileModalResponse
// 				open={responseModal.open}
// 				onClose={() => setResponseModal((prev: any) => ({ ...prev, open: false }))}
// 				isSuccess={responseModal.isSuccess}
// 				successMessage={responseModal.message}
// 				errorMessage={responseModal.message}
// 				responseData={responseModal.responseData}
// 			/>
// 		</Paper>
// 	);
// }
import React, { useState, useEffect } from 'react';
import {
	Box,
	Typography,
	Paper,
	TextField,
	IconButton,
	Button,
	Switch,
	Grid2,
} from '@mui/material';
import { motion } from 'framer-motion';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { MePUTADDress } from '../../../../../services/api/Vendorpage/me';
import ProfileModalResponse from '../../Vendor-ui/profilemodal';

interface Address {
	_id?: string;
	title: string;
	address?: string;
	city: string;
	country: string;
	state: string;
	zipCode: string;
	active?: boolean;
}

const addressSectionAnimation = {
	hidden: { opacity: 0, y: 20 },
	visible: (i: number) => ({
		opacity: 1,
		y: 0,
		transition: { delay: i * 0.1, duration: 0.4 },
	}),
};

export default function AddressCard({ Vendorme }: any) {
	const [addresses, setAddresses] = useState<Address[]>([]);
	const [editMode, setEditMode] = useState(false);
	const slug = localStorage.getItem('slug');
	const [responseModal, setResponseModal] = useState<any>({
		open: false,
		isSuccess: false,
		message: '',
		responseData: '',
	});

	useEffect(() => {
		if (Vendorme?.shippingAddress?.length > 0) {
			const mapped = Vendorme.shippingAddress.map((addr: any, i: number) => ({
				_id: addr?._id,
				title: `Shipping Address ${i + 1}`,
				address: addr?.address || '',
				city: addr?.city || '',
				country: addr?.country || '',
				state: addr?.state || '',
				zipCode: addr?.zipCode || '',
				active: addr?.active ?? false,
			}));
			setAddresses(mapped);
		}
	}, [Vendorme]);

	const handleChange = (index: number, field: keyof Address, value: string) => {
		const newAddresses = [...addresses];
		newAddresses[index] = { ...newAddresses[index], [field]: value };
		setAddresses(newAddresses);
	};

	const handleActiveSwitch = (index?: number) => {
		const updated = addresses.map((addr, i) => ({ ...addr, active: i === index }));
		setAddresses(updated);
	};

	const handleAddAddress = () => {
		const newAddress: Address = {
			title: `Shipping Address ${addresses.length + 1}`,
			address: '',
			city: '',
			country: '',
			state: '',
			zipCode: '',
			active: addresses.length === 0,
		};
		setAddresses([...addresses, newAddress]);
		setEditMode(true);
	};

	const handleSave = async () => {
		if (addresses.length === 0) return;
		const lastAddress = addresses[addresses.length - 1];
		const response = await MePUTADDress(`vendors/${slug}/me/shipping-address`, lastAddress);
		setResponseModal({
			open: true,
			isSuccess: response.success,
			message: response.success
				? 'Profile updated successfully!'
				: 'Failed to update profile!',
			responseData: null,
		});
		setEditMode(false);
	};

	return (
		<Paper
			component={motion.div}
			initial={{ opacity: 0, scale: 0.95 }}
			animate={{ opacity: 1, scale: 1 }}
			transition={{ duration: 0.5 }}
			sx={{
				borderRadius: 2,
				boxShadow: '0px 4px 4px rgba(0,0,0,0.1)',
				overflow: 'hidden',
				bgcolor: 'white',
				position: 'relative',
				width: '100%',
				maxWidth: 1200,
				mx: 'auto',
			}}
		>
			{/* Header */}
			<Box
				sx={{
					p: '5px',
					bgcolor: '#1B663C',
					display: 'flex',
					alignItems: 'center',
					px: 3,
					color: 'white',
					justifyContent: 'space-between',
				}}
				component={motion.div}
				initial={{ y: -50 }}
				animate={{ y: 0 }}
				transition={{ duration: 0.4 }}
			>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					<LocationOnIcon />
					<Typography
						sx={{ fontSize: { xs: 14, sm: 16, md: 18 } }}
						variant="h6"
						fontWeight={'semibold'}
						fontFamily="Poppins"
					>
						Shipping Address
					</Typography>
				</Box>
				<Box>
					<IconButton onClick={handleAddAddress} sx={{ color: 'white' }}>
						<AddLocationAltIcon />
					</IconButton>
					<IconButton onClick={() => setEditMode(!editMode)} sx={{ color: 'white' }}>
						<DriveFileRenameOutlineIcon />
					</IconButton>
				</Box>
			</Box>

			{/* Content */}
			<Box sx={{ p: 2, minHeight: '393px', overflowY: 'auto' }}>
				{addresses.map((addr, index) => (
					<Box key={addr._id || index} sx={{ mb: 2.5 }}>
						<Typography
							variant="h6"
							sx={{
								color: 'green',
								mb: 2,
								fontFamily: 'Poppins',
								fontWeight: 600,
								fontSize: { xs: 14, sm: 16, md: 18 },
							}}
							component={motion.div}
							custom={index}
							initial="hidden"
							animate="visible"
							variants={addressSectionAnimation}
						>
							{addr.title}
						</Typography>

						<Grid2 container spacing={2}>
							{editMode ? (
								<>
									<Grid2 size={{ xs: 12, sm: 4 }}>
										<TextField
											label="Door no / Street"
											variant="outlined"
											size="small"
											fullWidth
											value={addr.address}
											onChange={(e) =>
												handleChange(index, 'address', e.target.value)
											}
										/>
									</Grid2>
									<Grid2 size={{ xs: 12, sm: 4 }}>
										<TextField
											label="City"
											variant="outlined"
											size="small"
											fullWidth
											value={addr.city}
											multiline
											minRows={1}
											onChange={(e) =>
												handleChange(index, 'city', e.target.value)
											}
										/>
									</Grid2>
									<Grid2 size={{ xs: 12, sm: 4 }}>
										<TextField
											label="Country"
											variant="outlined"
											size="small"
											fullWidth
											value={addr.country}
											onChange={(e) =>
												handleChange(index, 'country', e.target.value)
											}
										/>
									</Grid2>
									<Grid2 size={{ xs: 12, sm: 4 }}>
										<TextField
											label="State"
											variant="outlined"
											size="small"
											fullWidth
											value={addr.state}
											onChange={(e) =>
												handleChange(index, 'state', e.target.value)
											}
										/>
									</Grid2>
									<Grid2 size={{ xs: 12, sm: 4 }}>
										<TextField
											label="Zip Code"
											variant="outlined"
											size="small"
											fullWidth
											value={addr.zipCode}
											onChange={(e) =>
												handleChange(index, 'zipCode', e.target.value)
											}
										/>
									</Grid2>
									<Grid2
										size={{ xs: 12, sm: 4 }}
										sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
									>
										<Typography variant="body2" color="text.secondary">
											Active
										</Typography>
										<Switch
											checked={addr.active ?? false}
											onChange={() => handleActiveSwitch(index)}
											color="success"
										/>
									</Grid2>
								</>
							) : (
								<>
									<Grid2 size={{ xs: 12, sm: 4 }}>
										<Typography variant="body2" color="text.secondary">
											Door no / Street
										</Typography>
										<Typography
											variant="body1"
											noWrap
											sx={{
												textOverflow: 'ellipsis',
												overflow: 'hidden',
												maxWidth: '100%',
											}}
										>
											{addr.address || '-'}
										</Typography>
									</Grid2>
									<Grid2 size={{ xs: 12, sm: 4 }}>
										<Typography variant="body2" color="text.secondary">
											City
										</Typography>
										<Typography
											variant="body1"
											noWrap
											sx={{
												textOverflow: 'ellipsis',
												overflow: 'hidden',
												maxWidth: '100%',
											}}
										>
											{addr.city}
										</Typography>
									</Grid2>
									<Grid2 size={{ xs: 12, sm: 4 }}>
										<Typography variant="body2" color="text.secondary">
											Country
										</Typography>
										<Typography
											variant="body1"
											noWrap
											sx={{
												textOverflow: 'ellipsis',
												overflow: 'hidden',
												maxWidth: '100%',
											}}
										>
											{addr.country}
										</Typography>
									</Grid2>
									<Grid2 size={{ xs: 12, sm: 4 }}>
										<Typography variant="body2" color="text.secondary">
											State
										</Typography>
										<Typography
											variant="body1"
											noWrap
											sx={{
												textOverflow: 'ellipsis',
												overflow: 'hidden',
												maxWidth: '100%',
											}}
										>
											{addr.state}
										</Typography>
									</Grid2>
									<Grid2 size={{ xs: 12, sm: 4 }}>
										<Typography variant="body2" color="text.secondary">
											Zip Code
										</Typography>
										<Typography
											variant="body1"
											noWrap
											sx={{
												textOverflow: 'ellipsis',
												overflow: 'hidden',
												maxWidth: '100%',
											}}
										>
											{addr.zipCode}
										</Typography>
									</Grid2>
									<Grid2 size={{ xs: 12, sm: 4 }}>
										<Typography variant="body2" color="text.secondary">
											Active
										</Typography>
										<Typography variant="body1">
											{addr.active ? 'Yes' : 'No'}
										</Typography>
									</Grid2>
								</>
							)}
						</Grid2>
					</Box>
				))}

				{editMode && (
					<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
						<Button
							variant="contained"
							sx={{ bgcolor: '#1B663C', px: 5, py: 1.5, borderRadius: 2 }}
							onClick={handleSave}
						>
							Save
						</Button>
					</Box>
				)}
			</Box>

			<ProfileModalResponse
				open={responseModal.open}
				onClose={() => setResponseModal((prev: any) => ({ ...prev, open: false }))}
				isSuccess={responseModal.isSuccess}
				successMessage={responseModal.message}
				errorMessage={responseModal.message}
				responseData={responseModal.responseData}
			/>
		</Paper>
	);
}
